import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AbcIconComponent } from '@barthauer/abc/ui-components/abc-icon';
import { AbcPopupDialogSettings } from './abc-popup-dialog.model';

@Component({
    selector: 'abc-popup-dialog',
    templateUrl: './abc-popup-dialog.component.html',
    styleUrl: './abc-popup-dialog.component.scss',
    imports: [CommonModule, AbcIconComponent]
})
export class AbcPopupDialogComponent {
  public settings: AbcPopupDialogSettings;

  constructor() {
    //
  }

  public getClasses(className: string): string[] {
    const classes: string[] = [className];

    if (this.settings.classExtension) {
      classes.push(className + '-' + this.settings.classExtension);
    }

    return classes;
  }
}
